import React from "react";
import Quote from "./Quote";

const App = () => {
  return (
    <div className="App">
      <Quote />
    </div>
  );
};

export default App;
